export default () => {
	const width = window.innerWidth - document.documentElement.clientWidth;
	return `${ width }px`;
};
